import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  yearText: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    marginLeft: -30,
    position: 'absolute',
    left: 0,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
    padding: '4px 20px',
    fontFamily: 'Sarabun, sans-serif',
    marginTop: -35,
  },
  timelineItem: {
    '&::before': {
      flex: 0,
      padding: 0,
    },
    minHeight: 'auto',
    '& .MuiTimelineContent-root': {
      paddingBottom: 30,
      paddingLeft: 75,
      paddingTop: 50,
      paddingRight: 0,
      '@media (max-width: 1023px)': {
        paddingLeft: 30,
      },
    },
  },
}));

export default function YearHeader({ year, children }) {
  const classes = useStyles();

  return (
    <TimelineItem className={classes.timelineItem}>
      <TimelineSeparator>
        <Box style={{ height: 100, position: 'relative' }}>
          <TimelineConnector
            style={{
              backgroundColor: '#0F6DF0',
              width: 5,
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              height: '100%',
            }}
          />
        </Box>

        <TimelineDot
          style={{
            backgroundColor: '#fff',
            border: '3px solid #0F6DF0',
            width: 30,
            height: 30,
            marginTop: -20,
            marginBottom: 4,
            zIndex: 1,
          }}
        />

        <TimelineConnector
          style={{
            backgroundColor: '#0F6DF0',
            width: 5,
            paddingBottom: 100,
          }}
        />
      </TimelineSeparator>

      <TimelineContent>
        <Typography className={classes.yearText}>
          ปี
          {' '}
          {year}
        </Typography>
        {children}
      </TimelineContent>
    </TimelineItem>
  );
}

/* ✅ PropTypes */
YearHeader.propTypes = {
  year: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  children: PropTypes.node,
};

YearHeader.defaultProps = {
  children: null,
};
